import { REF_MARKET_RESTRICTIONS } from 'constants/refMarketRestrictions';

export function getAllowedMarketIso2s(ref) {
  return REF_MARKET_RESTRICTIONS[ref] || null;
}

export function isMarketAllowedForRef(iso2, ref) {
  const allowed = getAllowedMarketIso2s(ref);
  if (!allowed) return true;
  return allowed.includes(iso2);
}

export function getDefaultMarketIso2ForRef(ref) {
  const allowed = getAllowedMarketIso2s(ref);
  if (!allowed) return 'US';
  return allowed.includes('US') ? 'US' : allowed[0];
}

export function filterMarketsByRef(markets, ref) {
  const allowed = getAllowedMarketIso2s(ref);
  if (!allowed || !markets) return markets;
  return markets
    .filter(({ iso2 }) => allowed.includes(iso2))
    .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
}

export function resolveMarketForRef(marketIso2, ref, marketsList) {
  const found = marketsList.find((m) => m.iso2 === marketIso2) || null;
  if (!getAllowedMarketIso2s(ref)) return found;
  if (found && isMarketAllowedForRef(marketIso2, ref)) return found;
  const defaultIso2 = getDefaultMarketIso2ForRef(ref);
  return marketsList.find((m) => m.iso2 === defaultIso2) || null;
}
